import styled from 'styled-components';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';

export const StyledDialog = styled(Dialog)`
    ${({ theme }) => `
    background: ${theme.palette.common.backdrop};
    backdrop-filter: blur(2px);
    `}
`;

export const StyledPaper = styled(Paper)`
    ${() => `
    background: linear-gradient(256.13deg, #FFFFFF 0%, rgba(255, 255, 255, 0.6) 100%);
    padding: 25px 20px 15px;
    margin-left: 10px;
    margin-right: 10px;
    border-radius: 16px;
    max-width: 500px;
    `}
`;

export const StyledPaperPermission = styled(Paper)`
    ${() => `
    border-radius: 12px;
    max-width: 500px;
    `}
`;

export const StyledPDPAPaper = styled(Paper)`
    ${({ theme }) => `
    background: linear-gradient(256.13deg, #FFFFFF 0%, rgba(255, 255, 255, 0.6) 100%);
    box-shadow: 0px 2px 4px rgba(132, 140, 183, 0.05);
    // backdrop-filter: blur(4px);

    border-radius: 16px;

    padding: 20px 20px 40px 20px;
    ${theme.breakpoints.up('md')} {
        padding: 35px 35px 40px 35px;
    }

    ${theme.breakpoints.up('lg')} {
    }
    `}
`;

export const StyledAccptButton = styled(Button)`
    ${() => `

    text-decoration: none;
    text-transform: none;
    border-radius: 8px;
    color: #AEB4D2;
    border: 1px solid #AEB4D2;

    height: 49px;
    width: 278px;
    
    &.MuiButton-text {
        padding: 4px 24px;
    }
    `}
`;

export const StyledDialogContent = styled(DialogContent)`
    ${() => `
    padding: 0 !important;
    `}
`;

export const StyledDialogActions = styled(DialogActions)`
    ${() => `
    margin-top: 15px;
    `}
`;

export const StyledRingingDialog = styled(Dialog)`
    ${({ theme, $desktopLayout }) => `
    background: ${theme.palette.common.backdrop};
    position: ${$desktopLayout ? 'fixed' : 'relative'};
    width: ${$desktopLayout ? '480px !important' : '100%'};
    height: ${$desktopLayout ? '512px !important' : '100%'};
    top: 50% !important;
    left: 50% !important;
    transform: translate(-50%, -50%) !important;
    border-radius: ${$desktopLayout ? '16px' : 0};
    z-index: 1301 !important;
    `}
`;
